// Imports MUI Components
import {  Box,
          Typography,
          Button } from "@mui/material"

// Import React
import { Link } from "react-router-dom";

// Import Assets
import caution from "../../../../assets/caution.png"
import verification from "../../../../assets/verification.png"
import success from "../../../../assets/approve.png"
import info from "../../../../assets/icons/info.png"
import trash from "../../../../assets/icons/trash.png"

// Import CSS
import "./styles.css"
import Icon from "../../atoms/icon/Icon";

const AlertComp = ({ 
  message, 
  isOpen, 
  onClose, 
  title, 
  image, 
  button, 
  buttonType, 
  destination,
  type,
  onConfirm
}) => {
  
  if (!isOpen) return null;

  // Styling
  const buttonStylesContainedDark = {
    color: 
    type === "remove" ? "#9F4223" :
    "#FDF9F3",
    background: 
      image === "caution" ? "#C5A572" : 
      image === "verify" ? "#2C6785" : 
      image === "success" ? "#2C6785" : 
      type === "remove" ? "rgba(118, 47, 47, .15)" :
      "#762f2fff",
    fontSize: "14px",
    borderRadius: 
      type === "remove" ? "10px" :
       "50px",
    padding: "15px 30px",
       justifyContent: type === "remove" ? "space-between" : null,
    margin: "0 0 16px 0",
    textTransform: "none",
    width: 
      type === "remove" ? "80%" :
       "80%",
    "&:hover": {
        color: 
          type === "remove" ? "#9F4223" :
          "#FFFFFF",
        backgroundColor: 
          image === "caution" ? "#8F7049" : 
          image === "verify" ? "#1c4357ff" : 
          image === "success" ? "#3f90b8ff" : 
          type === "remove" ? "rgba(118, 47, 47, 0.30)" :
          "#8F7049",
    },
    // color: "#C5A572",
    // backgroundColor: "#FEFEFE",
    // fontSize: "14px",
    // border: "1px solid #C5A572",
    // borderRadius: "50px",
    // padding: "15px 30px",
    // margin: "0 0 16px 0",
    // textTransform: "none",
    // width: "80%",
    // "&:hover": {
    //   color: "#FDF9F3",
    //   border: "1px solid #AD8C60",
    //   backgroundColor: "#E1BB88",
    // },
  }

  return (
    <div>
      {/* All Container */}
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          background: "rgba(0,0,0,0.6)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 99999,
        }}>
        
        {/* Modal Container */}
        <Box
          sx={{
            background: "#fff",
            borderRadius: "16px",
            textAlign: "center",
            minWidth: "300px",
            maxWidth: "400px",
            padding: "24px",
            boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
          }}>

          {/* Close Button */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "end",
              position: "sticky"
            }}>
            
            <Button
              disableRipple
              onClick={onClose}
              sx={{
              background: "none",
              color: "#2C251E",
              // border: "1px solid #2C251E",
              padding: "7px",
              borderRadius: "50px",
              // fontSize: "24px",
              cursor: "pointer",
              minWidth: "40px",
              minHeight: "40px",
              ":hover": {
                background: "rgba(0, 0, 0, 0.1)"
              }
              }}>

              <Icon
                src={require("../../../../assets/icons/close.png")}
                size="small"/>

            </Button>
            
          </Box>

          {/* Image Container */}
          <Box
            sx={{
              // background: "#5f3131ff",
              margin: "0 0 12px 0",
            }}>

            {/* Image */}
            <img 
              alt="image"
              className={
                image === "info" ? "alertImageInfo" :
                "alertImage"
              }
              src={
                image === "caution" ? (
                  caution
                ) : image === "verify" ? (
                  verification
                ) : image === "success" ? (
                  success
                ) : image === "info" ? (
                  info
                ) : (
                  caution
                )
              }/>

          </Box>

          {/* Text */}
          <Typography
            variant="h2"
              sx={{
                margin: "0 20px 16px 20px",
                color: "#2C251E",
                // background: "#2C251E",
                fontWeight: "600",
                fontSize: "24px",
              }}>{title}
          </Typography>

          {/* Text */}
          <Typography
            variant="h3"
              sx={{
                margin: "0 24px 16px 24px",
                color: "#2C251E",
                // background: "#2C251E",
                fontWeight: "300",
                fontSize: "17px",
                lineHeight: "1.4",
                letterSpacing: "0.3px",
              }}>{message}
          </Typography>

          {/* Button Container */}
          <Box>

            {destination === "none" ? (
              <>
                {type === "remove" ? (
                  <Button
                    disabled={buttonType}
                    // type="submit"
                    onClick={onConfirm}
                    variant="contained"
                    disableElevation
                    sx={buttonStylesContainedDark}
                    >{button}
                    <Icon
                      src={trash}
                      size="small"/>
                  </Button>
                ) : (
                  <Button
                    disabled={buttonType}
                    type="submit"
                    onClick={onClose}
                    variant="contained"
                    disableElevation
                    sx={buttonStylesContainedDark}
                    >{button}
                  </Button>
                )}
              
              </>
            ) : (
              <Link to={destination}>

                <Button
                  disabled={buttonType}
                  type="submit"
                  variant="contained"
                  disableElevation
                  sx={buttonStylesContainedDark}
                  >{button}
                </Button>

              </Link>
            )}
                
          </Box>

        </Box>

      </Box>

    </div>
  );
};

export default AlertComp; 